<my-bill-odb-page-base-structure
  [billingDocument]="billDocument"
  [hasCommonHeader]="true"
  [customTitle]="headerTitle | translate"
>
  <!--///////////////   LEFT Column content   /////////////////-->
  <ng-container leftColumnContent *ngIf="billDocument">
    <div class="rs-panel-big rs-bg-c2 rs-margin-bottom4-m">
      <p class="rs-tit2 rs-padding-bottom1">
        {{ 'bills.redesign.overview.balanceCard.totalToPay' | translate }}
      </p>
      <p>
        <px-currency-amount
          [amount]="billDocument.totalAmount"
          [amountClass]="'rs-price-sm'"
        ></px-currency-amount>
        {{ 'bills.cover.vatInclusiveWithSlash' | translate }}
      </p>
    </div>
    <my-bill-download-card
      [billDocument]="billDocument"
      [customerId]="selectedCustomer?.customerId"
      [billingAccount]="billingAccount"
      [buttonZone]="'mybill.detail'"
    ></my-bill-download-card>
  </ng-container>
  <ng-container rightColumnContent>
    <div class="rs-panel-big rs-bg-c2" *ngIf="customerPaymentProfile">
      <my-bill-options
        [billDocument]="billDocument"
        [billingAccount]="billingAccount"
        [customerPaymentProfile]="customerPaymentProfile"
      ></my-bill-options>
    </div>
    <div class="rs-panel-big rs-bg-c2">
      <my-bill-faq
        [billingDocument]="billDocument"
        [billingAccount]="billingAccount"
        [hasSplitLine]="false"
        [isResUser]="isResUser"
        [zone]="'mybill.detail'"
      ></my-bill-faq>
    </div>
  </ng-container>
</my-bill-odb-page-base-structure>
